module.exports = __webpack_public_path__ + "static/img/200223.a9d76d97.png";